import {
  Activity,
  Baby,
  BedDouble,
  ClipboardList,
  FlaskConical,
  Headset,
  HeartPulse,
  Microscope,
  Pill,
  ShieldCheck,
  Sparkles,
  Syringe,
  TestTube,
  Truck,
  Video,
} from "lucide-react";


export const SERVICES = [
  { key: "mcu",          slug: "mcu",           Icon: ClipboardList, image: "/images/layanan/medical-check-up.png", siap: true },
  { key: "igd",          slug: "igd",           Icon: Activity,      image: "/images/layanan/igd.jpg",              siap: true, urgent: true },
  { key: "laboratorium", slug: "laboratorium",  Icon: FlaskConical,  image: "/images/layanan/lab.jpg",              siap: true },
  { key: "apotek",       slug: "apotek",        Icon: Pill,          image: "/images/layanan/apotek.png",           siap: true },
  { key: "rawatInap",    slug: "rawat-inap",    Icon: BedDouble,     image: "/images/layanan/ranap.jpg",            siap: true },
  { key: "pelayanan",    slug: "pelayanan",     Icon: Headset,       image: "/images/layanan/pelayanan2.png",       siap: true },
  { key: "asuransi",     slug: "asuransi",      Icon: ShieldCheck,   image: "/images/asuransi.png",                 siap: true },
   

  /* ---- SISANYA HANYA DI HALAMAN INDEKS DAN DROPDOWN ---- */
  { key: "telemedicine",     slug: "telemedicine",      Icon: Video,       image: "/images/medic.png",              siap: true },
  { key: "deliveryObat",     slug: "delivery-obat",     Icon: Truck,       image: "/images/layanan/delivery.png",   siap: true },
  { key: "swabPcr",          slug: "swab-pcr",          Icon: TestTube,    image: "/images/layanan/swabpcr.png",    siap: true },
  { key: "babySpa",          slug: "baby-spa",          Icon: Baby,        image: "/images/layanan/babyspa.png",    siap: true },
  { key: "klinikNyeri",      slug: "klinik-nyeri",      Icon: HeartPulse,  image: "/images/klinik-nyeri.png",       siap: true },
  { key: "terapiWasir",      slug: "terapi-wasir",      Icon: Syringe,     image: "/images/terapiw.png",            siap: true },
  { key: "endoskopiUrologi", slug: "endoskopi-urologi", Icon: Microscope,  image: "/images/endoskopiu.png",         siap: true },
  { key: "skincare",         slug: "jmc-skincare",      Icon: Sparkles,    image: "/images/jmcskincare.png",        siap: true },
];

export const JUMLAH_DI_BERANDA = 7;

export const SERVICES_BERANDA = SERVICES.slice(0, JUMLAH_DI_BERANDA);

export const layananHref = (slug) => `/layanan/${slug}`;

export const getService = (slug) =>
  SERVICES.find((service) => service.slug === slug) ?? null;

/* ============================================================
   YANG BELUM DIKERJAKAN

   1. NAMA BERKAS `pelayanan2.png`. Angka 2 biasanya sisa percobaan.
      Kalau tidak ada `pelayanan.png` yang dipakai di tempat lain,
      ganti namanya sekarang selagi rujukannya cuma satu baris -
      nama berkas berangka acak menumpuk cepat, dan setahun lagi
      tidak ada yang tahu mana yang benar-benar dipakai.

      Kalau diganti, ubah juga baris pelayanan di atas.

   2. RASIO FOTO 16:10. Kartu di halaman indeks memakai rasio itu;
      foto berasio lain tetap tampil, hanya terpotong di sisi yang
      berlebih. Poster pelayanan biasanya berformat tegak, jadi
      PERIKSA hasilnya - kalau bagian pentingnya terpotong, foto itu
      perlu dipotong ulang ke 1200x750 px.

      Medan `fokus` yang dipakai CenterOfExcellence.jsx TIDAK berlaku
      di sini; komponen yang membaca berkas ini belum mengenalnya.

   3. FOTO ASURANSI masih kosong. Lihat catatan di barisnya.

   4. DROPDOWN HEADER MASIH MENAUTKAN SEMUANYA, termasuk layanan yang
      `siap: false` - saat ini tidak ada, tapi penanda itu akan
      diabaikan lagi begitu ada layanan baru yang halamannya belum
      dibuat.

      Kalau kamu ingin menu ikut aman, item yang belum siap perlu
      dirender sebagai teks biasa, bukan <Link>. Itu suntingan di
      Header.jsx, bukan di berkas ini.

   5. EMPAT HALAMAN LAYANAN YANG SUDAH ADA menyimpan
      `const TAUTKAN_INDUK = false;` dengan komentar "ubah ke true
      begitu app/layanan/page.jsx dibuat". Halaman itu sekarang ADA,
      jadi ubah keempatnya:

        app/layanan/igd/IgdContent.jsx           baris 53
        app/layanan/mcu/MCUContent.jsx           baris 64
        app/layanan/laboratorium/Laboratorium... baris 45
        app/layanan/swab-pcr/SwabPcrContent.jsx  baris 41
   ============================================================ */
